import React from "react"
import * as Yup from "yup"
import { Form, Formik, FormikHelpers } from "formik"
import { toast } from "react-toastify"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"
import MyTextareaFormField from "@common-components/fields/MyTextareaFormField"
import { CONST_API_RECRUITMENT_CANDIDATES_POST_CREATE_COMMENT_ENDPOINT } from "../../../../endpoints"
import axios from "axios"

interface Props {
     candidat: {
          id: number | string
          prenomNom: string
          type: string
     }
     handleSubmitCallBack: (newSuivi?: any) => void
     onCancel?: () => void
}

const CandidatAddSuiviCommentaireSimple: React.FC<Props> = ({ candidat, handleSubmitCallBack, onCancel }) => {
     // Schéma de validation
     const schema = Yup.object().shape({
          commentaire: Yup.string().required("Le commentaire ne peut pas être vide").min(3, "Le commentaire est trop court").label("Commentaire"),
     })

     const initialValues = { commentaire: "" }

     const handleSubmit = (values: typeof initialValues, helpers: FormikHelpers<typeof initialValues>) => {
          helpers.setStatus(null)

          // Correction de la syntaxe du payload : le contrôleur attend une clé 'commentaire'
          axios.post(CONST_API_RECRUITMENT_CANDIDATES_POST_CREATE_COMMENT_ENDPOINT(candidat.id), {
               commentaire: values.commentaire,
          })
               .then(r => {
                    toast.success("Commentaire ajouté avec succès")
                    handleSubmitCallBack(r.data)
               })
               .catch(e => {
                    const detail = e.response?.data?.detail || "Erreur lors de l'ajout du commentaire"
                    helpers.setStatus(detail)
                    toast.error(detail)
               })
               .finally(() => {
                    helpers.setSubmitting(false)
               })
     }

     return (
          <Formik initialValues={initialValues} validationSchema={schema} onSubmit={handleSubmit}>
               {formik => (
                    <Form noValidate autoComplete="off" className="d-flex flex-column h-100">
                         {formik.status && (
                              <div className="alert alert-danger d-flex align-items-center p-4 mb-6">
                                   <i className="bi bi-exclamation-triangle-fill fs-4 text-danger me-3"></i>
                                   <div className="fw-bold">{formik.status}</div>
                              </div>
                         )}

                         <MyTextareaFormField
                              label="Votre commentaire"
                              name="commentaire"
                              placeholder="Saisissez ici les informations importantes concernant le candidat..."
                              formikProps={formik}
                              minRows={10}
                         />

                         <div className="d-flex justify-content-end gap-3 mt-auto pt-4 border-top">
                              {onCancel && (
                                   <button type="button" className="btn btn-sm btn-light fw-bold" onClick={onCancel} disabled={formik.isSubmitting}>
                                        Annuler
                                   </button>
                              )}
                              <button type="submit" className="btn btn-sm btn-primary fw-boldest px-8" disabled={formik.isSubmitting || !formik.isValid}>
                                   {!formik.isSubmitting ? (
                                        <>
                                             <i className="fas fa-paper-plane me-2"></i>
                                             Enregistrer le commentaire
                                        </>
                                   ) : (
                                        <MySimpleSpinner size="sm" />
                                   )}
                              </button>
                         </div>
                    </Form>
               )}
          </Formik>
     )
}

export default CandidatAddSuiviCommentaireSimple
